import { createComponentStore } from '../../utils/createComponentStore';

const { getStore, defaultStore } = createComponentStore({
  type: 'branch_paths',
  endpoint: 'branch_paths',
  registryKey: 'branch_paths',
  initData: () => ({}),

  extraActions: (set) => ({
    setComponentName: (name) => set({ name }),
  }),
});

export const getBranchPathsStore = getStore;
export default defaultStore;
